import { AppStartPresenterFunc, AppStatus } from '@/core/interface/app/presenter';
import { IAuthGateway } from '@/core/interface/auth/gateway';

export class StartApp {
  constructor(
    private readonly authGateway: IAuthGateway,
  ) { }

  public async execute(presenter: AppStartPresenterFunc) {
    // get current user
    const user = await this.authGateway.getCurrentUser(true);

    if (user === null) {
      // no current user, navigate to sign in
      presenter(null, AppStatus.READY, user);

      return;
    }

    // navigate to home
    presenter(null, AppStatus.READY, user);
  }
}
